import React from 'react';

const JoinWaitlistSection = () => {
  return (
    <section
      id="join"
      className="bg-soft-earth section-wrapper"
    >
      <div className="max-w-xl mx-auto text-center">
        <h3 className="text-3xl font-bold text-primary mb-4">Join the Co-op</h3>
        <p className="text-gray-700 mb-6 text-md md:text-lg">
          Whether you’re a shop owner, market vendor, or just exploring ideas —
          we’d love to hear from you. Click below to let us know you’re
          interested, and we’ll keep you in the loop as we grow.
        </p>

        <a
          href="mailto:join@betterturns.com?subject=Join the Co-op Waitlist&body=Hi Better Turns team,%0D%0A%0D%0AI’m interested in joining the Co-op. Here’s my info:%0D%0A%0D%0AName:%0D%0AStore Name:%0D%0ALocation:%0D%0AContact Email:%0D%0A%0D%0ALooking forward to hearing from you!"
          className="inline-block bg-primary text-white font-semibold px-6 py-3 rounded shadow hover:bg-primary-dark transition"
        >
          Join the Waitlist
        </a>
      </div>
    </section>
  );
};

export default JoinWaitlistSection;
